import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import {
  CatatanApprovalSection,
  FormSection,
  InfoProgramSection,
} from "./Section";
import {
  formInitialValues,
  formSubmmitMapper,
  formValidationSchema,
} from "./Utils";
import { Formik } from "formik";
import { KegiatanApi } from "api";
import { useParams, useHistory } from "react-router-dom/cjs/react-router-dom";
import { ActionButton, BackButton, DataStatus } from "components";

export const DetailKegiatan = () => {
  const { id } = useParams();
  const history = useHistory();
  const [dataKegiatan, setDataKegiatan] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    variant: "primary",
    text: "",
    show: false,
  });
  const getDataSingle = () => {
    setIsLoading(true);
    KegiatanApi.getSingle({ id_kegiatan: id })
      .then(({ data }) => {
        setDataKegiatan(data?.data);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formSubmitHandler = (value, { setSubmitting }) => {
    KegiatanApi.update(formSubmmitMapper(value))
      .then(() => {
        history.push("/transaksi/kegiatan", {
          alert: {
            show: true,
            variant: "success",
            text: "Data berhasil diubah!",
          },
        });
      })
      .catch(() => {
        setAlertConfig({
          show: true,
          text: "Data gagal disimpan !!",
          variant: "danger",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    getDataSingle();

    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={formInitialValues(dataKegiatan)}
        validationSchema={formValidationSchema}
        onSubmit={formSubmitHandler}
      >
        {({ isSubmitting, handleSubmit, resetForm }) => (
          <>
            {isLoading ? (
              <DataStatus text="Memuat Data..." loading />
            ) : (
              <>
                <div className="d-flex justify-content-between mb-2">
                  <span style={{ fontSize: "14px" }}>
                    <b>Detail Data Program</b>
                  </span>
                  <BackButton size="sm" onClick={() => history.goBack()} />
                </div>
                <Card className="mb-3">
                  <Card.Body>
                    <InfoProgramSection />
                  </Card.Body>
                </Card>
                <span style={{ fontSize: "14px" }}>
                  <b>Detail Data Kegiatan</b>
                </span>
                <Card className="mb-3">
                  <Card.Body>
                    <form onSubmit={handleSubmit}>
                      <FormSection type="read" />
                    </form>
                  </Card.Body>
                </Card>
                <CatatanApprovalSection data={dataKegiatan?.stakeholder} />
              </>
            )}
          </>
        )}
      </Formik>
    </>
  );
};
